/* eslint-disable react/no-array-index-key */
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Tooltip } from '@mui/material';
import React from 'react';
import { ColorPalette } from '../../../../../components/config';

interface ILabelWithHelpIconProps {
  label: string;
  helpTexts?: string[];
}

export function LabelWithHelpIcon(props: ILabelWithHelpIconProps) {
  const { label, helpTexts } = props;
  return (
    <Box display="flex" justifyContent="center" gap={1}>
      {label}
      {helpTexts && (
        <Tooltip
          title={
            <Box display="flex" flexDirection="column">
              {helpTexts.map((x, i) => (
                <Box key={i}>
                  {x}
                  <br />
                </Box>
              ))}
            </Box>
          }
        >
          <FontAwesomeIcon icon={faInfoCircle} color={ColorPalette.InfoIcon} />
        </Tooltip>
      )}
    </Box>
  );
}
